import { render, staticRenderFns } from "./videolist.vue?vue&type=template&id=3cefa678&scoped=true&"
import script from "./videolist.vue?vue&type=script&lang=js&"
export * from "./videolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cefa678",
  null
  
)

export default component.exports